export default "__VITE_ASSET__9vnzWxhi__"